var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return "string_vertical" == _vm.item.type || "string" == _vm.item.type
    ? _c(
        "div",
        { staticStyle: { position: "relative" } },
        [
          _c("el-input", {
            staticClass: "form_input_1",
            attrs: { type: "textarea", rows: 1, placeholder: _vm.item.id },
            on: { change: _vm.onChange },
            model: {
              value: _vm.properties[_vm.item.id],
              callback: function($$v) {
                _vm.$set(_vm.properties, _vm.item.id, $$v)
              },
              expression: "properties[item.id]"
            }
          }),
          _vm._v(" "),
          _vm.item.enums && _vm.item.enums.length > 0
            ? [
                _c("i", {
                  staticClass: "icon_1 el-icon-arrow-down",
                  on: { click: _vm.showSuggestions }
                }),
                _vm._v(" "),
                _c(
                  "el-dialog",
                  {
                    staticClass: "dialog_1",
                    attrs: {
                      top: "0",
                      modal: false,
                      "show-close": false,
                      visible: _vm.dialogVisible
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.dialogVisible = $event
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticStyle: { height: "0", "margin-top": "-10px" },
                      attrs: { slot: "title" },
                      slot: "title"
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.item.enums, function(e) {
                      return _c(
                        "span",
                        {
                          key: e.id,
                          staticClass: "item_23",
                          on: {
                            click: function($event) {
                              return _vm.onSelected_24(e, _vm.item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(e.id))]
                      )
                    })
                  ],
                  2
                )
              ]
            : _vm._e()
        ],
        2
      )
    : "textarea_vertical" == _vm.item.type
    ? _c("el-input", {
        attrs: {
          type: "textarea",
          autosize: { minRows: 2 },
          placeholder: _vm.item.id
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "long_vertical" == _vm.item.type || "long" == _vm.item.type
    ? _c("el-input", {
        staticClass: "ticket_form_long",
        attrs: { placeholder: _vm.item.id },
        on: { input: _vm.onNumberInput },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "double_vertical" == _vm.item.type || "double" == _vm.item.type
    ? _c("el-input-number", {
        attrs: {
          precision: 2,
          "controls-position": "right",
          placeholder: _vm.item.id
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "boolean_vertical" == _vm.item.type || "boolean" == _vm.item.type
    ? _c(
        "el-select",
        {
          attrs: { clearable: "", placeholder: _vm.item.id },
          on: { change: _vm.onChange },
          model: {
            value: _vm.properties[_vm.item.id],
            callback: function($$v) {
              _vm.$set(_vm.properties, _vm.item.id, $$v)
            },
            expression: "properties[item.id]"
          }
        },
        _vm._l(
          [
            { label: "是", value: "true" },
            { label: "否", value: "false" }
          ],
          function(item) {
            return _c("el-option", {
              key: item.value,
              attrs: { label: item.label, value: item.value }
            })
          }
        ),
        1
      )
    : "enum_vertical" == _vm.item.type || "enum" == _vm.item.type
    ? _c(
        "el-select",
        {
          attrs: { clearable: "", placeholder: _vm.item.id },
          on: { change: _vm.onEnumChange },
          model: {
            value: _vm.properties[_vm.item.id],
            callback: function($$v) {
              _vm.$set(_vm.properties, _vm.item.id, $$v)
            },
            expression: "properties[item.id]"
          }
        },
        _vm._l(_vm.item.enums, function(item) {
          return _c("el-option", {
            key: item.id,
            attrs: { label: item.name, value: item.id }
          })
        }),
        1
      )
    : "budo_date_vertical" == _vm.item.type || "budo_date" == _vm.item.type
    ? _c("el-date-picker", {
        attrs: {
          type: "date",
          placeholder: _vm.item.id,
          "value-format": _vm.item.expression
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "datetime_vertical" == _vm.item.type || "datetime" == _vm.item.type
    ? _c("el-date-picker", {
        attrs: { type: "datetime", placeholder: _vm.item.id },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "datetime_range_vertical" == _vm.item.type ||
      "datetime_range" == _vm.item.type
    ? _c("el-date-picker", {
        attrs: {
          type: "datetimerange",
          "unlink-panels": "",
          "start-placeholder": "开始",
          "end-placeholder": "结束"
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "date_range_vertical" == _vm.item.type || "date_range" == _vm.item.type
    ? _c("el-date-picker", {
        attrs: {
          type: "daterange",
          "unlink-panels": "",
          "start-placeholder": "开始",
          "end-placeholder": "结束"
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "month_vertical" == _vm.item.type || "month" == _vm.item.type
    ? _c("el-date-picker", {
        attrs: { type: "month", placeholder: "选择月" },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "week_vertical" == _vm.item.type || "week" == _vm.item.type
    ? _c("el-date-picker", {
        attrs: { type: "week", format: "yyyy-MM-dd 周", placeholder: "选择周" },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "time_vertical" == _vm.item.type || "time" == _vm.item.type
    ? _c("el-time-picker", {
        attrs: {
          placeholder: _vm.item.id,
          "value-format": _vm.item.expression
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "time_range_vertical" == _vm.item.type || "time_range" == _vm.item.type
    ? _c("el-time-picker", {
        attrs: {
          "is-range": "",
          placeholder: _vm.item.id,
          "value-format": _vm.item.expression
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : ("upload_vertical" == _vm.item.type || "upload" == _vm.item.type) &&
      "show" != _vm.mode
    ? _c(
        "el-upload",
        {
          attrs: {
            multiple: "",
            data: _vm.uploadToken,
            action: "//upload-z0.qiniup.com",
            "before-upload": _vm.beforeUpload,
            "on-success": _vm.uploadSuccess
          }
        },
        [_c("el-button", [_vm._v(_vm._s(_vm.uploadButtonText))])],
        1
      )
    : ("upload_vertical" == _vm.item.type || "upload" == _vm.item.type) &&
      "show" == _vm.mode &&
      _vm.properties[_vm.item.id] &&
      _vm.isImage(_vm.properties[_vm.item.id].url)
    ? _c(
        "div",
        [
          _c(
            "el-popover",
            { attrs: { placement: "top-end", trigger: "hover" } },
            [
              _c("p", [
                _c("img", {
                  staticClass: "img_upload_1",
                  attrs: {
                    src: _vm.properties[_vm.item.id]
                      ? _vm.properties[_vm.item.id].url
                      : "no-url-3"
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "el-button",
                  staticStyle: { width: "100%" },
                  attrs: {
                    slot: "reference",
                    target: "_blank",
                    href: _vm.properties[_vm.item.id]
                      ? _vm.properties[_vm.item.id].url
                      : "no-url-1"
                  },
                  slot: "reference"
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        !!_vm.properties[_vm.item.id] &&
                          !!_vm.properties[_vm.item.id].url
                          ? "文件下载"
                          : "未上传文件[2]"
                      ) +
                      "\n        " +
                      _vm._s(
                        _vm.properties[_vm.item.id]
                          ? _vm.properties[_vm.item.id].name
                          : "no-name-2"
                      ) +
                      "\n    "
                  )
                ]
              )
            ]
          )
        ],
        1
      )
    : ("upload_vertical" == _vm.item.type || "upload" == _vm.item.type) &&
      "show" == _vm.mode
    ? _c("div", [
        _c(
          "a",
          {
            staticClass: "el-button",
            staticStyle: {
              width: "100%",
              overflow: "hidden",
              "text-overflow": "ellipsis"
            },
            attrs: {
              slot: "reference",
              target: "_blank",
              href: _vm.properties[_vm.item.id]
                ? _vm.properties[_vm.item.id].url
                : "no-url-4"
            },
            slot: "reference"
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  !!_vm.properties[_vm.item.id] &&
                    !!_vm.properties[_vm.item.id].url
                    ? "文件下载"
                    : "未上传文件[1]"
                ) +
                "\n      " +
                _vm._s(
                  _vm.properties[_vm.item.id]
                    ? _vm.properties[_vm.item.id].name
                    : "no-name-5"
                ) +
                "\n  "
            )
          ]
        )
      ])
    : "merchant_linkage" == _vm.item.type ||
      "merchant_vertical" == _vm.item.type ||
      "merchant" == _vm.item.type
    ? _c("MerchantSearch", {
        attrs: { id: _vm.item.id },
        on: { change: _vm.onMerchantChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "line" == _vm.item.type
    ? _c("LineSearch", {
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "order_vertical" == _vm.item.type ||
      "order" == _vm.item.type ||
      "order_linkage" == _vm.item.type
    ? _c("MerchantOrderSearch", {
        on: { change: _vm.onOrderChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "ticket_form_vertical" == _vm.item.type && "new" == _vm.mode
    ? _c(
        "div",
        [
          _c("TicketSearch", {
            on: { change: _vm.onChange },
            model: {
              value: _vm.properties[_vm.item.id],
              callback: function($$v) {
                _vm.$set(_vm.properties, _vm.item.id, $$v)
              },
              expression: "properties[item.id]"
            }
          })
        ],
        1
      )
    : "ticket_form_vertical" == _vm.item.type && "show" == _vm.mode
    ? _c(
        "div",
        { staticStyle: { "box-shadow": "-1px -1px 15px 1px #F2F2E2" } },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c("span", [_vm._v("----- -----")]),
              _vm._v(" "),
              _c("span", [_vm._v("引用工单")]),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href: "/ticket/t/" + _vm.properties[_vm.item.id]
                  }
                },
                [
                  _vm._v(
                    "\n      #" + _vm._s(_vm.properties[_vm.item.id]) + "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c("TicketTitleByNo", {
                model: {
                  value: _vm.properties[_vm.item.id],
                  callback: function($$v) {
                    _vm.$set(_vm.properties, _vm.item.id, $$v)
                  },
                  expression: "properties[item.id]"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("----- -----")])
            ],
            1
          ),
          _vm._v(" "),
          _c("TicketTaskForm", {
            staticStyle: { margin: "0 -20px 0 -20px" },
            attrs: { ticketNo_2: _vm.properties[_vm.item.id], mode_0: "show" }
          })
        ],
        1
      )
    : "merchant_order_vertical_linkage" == _vm.item.type ||
      "merchant_order_vertical" == _vm.item.type
    ? _c("MerchantOrderSearchComplex", {
        on: { change: _vm.onMerchantOrderChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "ticket_user" == _vm.item.type || "ticket_user_vertical" == _vm.item.type
    ? _c("DealUserSearch", {
        attrs: { id: _vm.fromDialog == "Yes" ? null : _vm.item.id },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "multi_ticket_user" == _vm.item.type ||
      "multi_ticket_user_vertical" == _vm.item.type
    ? _c("NoticeUserSearch", {
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "summernote_vertical" == _vm.item.type
    ? _c("EditorSummernote", {
        attrs: { minHeight: "100px", id: "TicketTaskFormItem_" + _vm.item.id },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "divider_vertical" == _vm.item.type || "divider" == _vm.item.type
    ? _c("div")
    : "district_vertical" == _vm.item.type || "district" == _vm.item.type
    ? _c("TicketFormDistrict", {
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "radio_vertical" == _vm.item.type || "radio" == _vm.item.type
    ? _c("TicketFormRadio", {
        attrs: { item: _vm.item },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "checkbox_vertical" == _vm.item.type || "checkbox" == _vm.item.type
    ? _c("TicketFormCheckbox", {
        attrs: { item: _vm.item },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "slider_vertical" == _vm.item.type || "slider" == _vm.item.type
    ? _c("TicketFormSlider", {
        attrs: { item: _vm.item },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "rate_vertical" == _vm.item.type || "rate" == _vm.item.type
    ? _c("TicketFormRate", {
        attrs: { item: _vm.item },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "switch_vertical" == _vm.item.type || "switch" == _vm.item.type
    ? _c("TicketFormSwitch", {
        attrs: { item: _vm.item },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "auth_vertical" == _vm.item.type || "auth" == _vm.item.type
    ? _c("TicketFormAuth", {
        attrs: { item: _vm.item },
        on: { change: _vm.onChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "shop_vertical" == _vm.item.type || "shop" == _vm.item.type
    ? _c("TicketFormShop", {
        on: { change: _vm.onShopChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "phone_verified_vertical" == _vm.item.type
    ? _c("TicketFormPhoneVerified", {
        ref: "PhoneVerified",
        on: { change: _vm.onShopChange },
        model: {
          value: _vm.properties[_vm.item.id],
          callback: function($$v) {
            _vm.$set(_vm.properties, _vm.item.id, $$v)
          },
          expression: "properties[item.id]"
        }
      })
    : "RelatedApproval" == _vm.item.type
    ? _c("WorkWeixinRelatedApproval")
    : _c("div", [_vm._v("其他表单类型 " + _vm._s(_vm.item))])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3dfbd32a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dfbd32a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketTaskFormItem.vue
// module id = 716
// module chunks = 75